import {
	CRUDBase,
	DeleteSingleEntityPayload,
	GetAllMeta,
	GetSingleEntityPayload,
} from '@Base/services/services.base';
import api from '@Services/api';
import { AxiosResponse } from 'axios';
import { TestQuestion, TestQuestionPayload } from '../../Types/TestQuestion';

interface TQCRUDBase extends CRUDBase<TestQuestionPayload, TestQuestion> {
	reorder(payload: Array<any>): Promise<AxiosResponse<ApiResponse<any>>>;
}
export class TestQuestionsRequester implements TQCRUDBase {
	async reorder(payload: any): Promise<AxiosResponse<ApiResponse<any>>> {
		return await api.post(`${this.baseURL}reorder`, payload);
	}
	public static instance: TestQuestionsRequester = new TestQuestionsRequester();
	baseURL = 'test/questions/';
	getAll(
		payload?: GetAllMeta
	): Promise<AxiosResponse<ApiResponse<TestQuestion[]>>>;
	getAll(payload: number): Promise<AxiosResponse<ApiResponse<TestQuestion[]>>>;
	async getAll(
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<TestQuestion[]>>> {
		return await api.post(`${this.baseURL}fetch`, payload);
	}
	get(id: string): Promise<AxiosResponse<ApiResponse<TestQuestion>>>;
	get(id: number): Promise<AxiosResponse<ApiResponse<TestQuestion>>>;
	get(
		id: string | number,
		payload?: GetSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<TestQuestion>>>;
	async get(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<TestQuestion>>> {
		return await api.post(`${this.baseURL}get`, { id });
	}
	async create(
		payload: Omit<TestQuestionPayload, 'id'>
	): Promise<AxiosResponse<ApiResponse<TestQuestion>>> {
		return await api.post(`${this.baseURL}create`, payload);
	}
	async update(
		payload: TestQuestionPayload
	): Promise<AxiosResponse<ApiResponse<TestQuestion>>> {
		return await api.post(`${this.baseURL}update`, payload);
	}
	delete(id: number): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(id: string): Promise<AxiosResponse<ApiResponse<any>>>;
	delete(
		id: string | number,
		payload?: DeleteSingleEntityPayload
	): Promise<AxiosResponse<ApiResponse<any>>>;
	async delete(
		id: any,
		payload?: any
	): Promise<import('axios').AxiosResponse<ApiResponse<any>>> {
		return await api.delete(`${this.baseURL}delete`, { data: { id } });
	}
}
